import { render, staticRenderFns } from "./MessageConsultantPopup.vue?vue&type=template&id=90c6d46e"
import script from "./MessageConsultantPopup.vue?vue&type=script&lang=js"
export * from "./MessageConsultantPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports